import Axios from "axios";
import Apis from "../../config/Apis";
import { hideLoading, showAlert, showLoading } from "../Actions/GeneralActions";
// import { headers } from "../../Utils";
import {
  addNewVendor,
  clearFindVendors,
  clearFindVendorsByCat,
  clearSubContacts,
  clearYourVendors,
  getFindVendors,
  getFindVendorsByCat,
  getSubContacts,
  getVendorDetails,
  getYourVendors,
  removeVendorFromEvent,
  updateSubContacts,
  removeSubVendor,
} from "../Actions/VendorActions";
import { headers } from "../../utills";

export const VendorMiddleware = {
  getFindVendors: (filterData = null) => {
    return (dispatch) => {
      dispatch(showLoading());
      if (filterData?.next_page_url) dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (
            filterData?.findVendor_name ||
            filterData?.next_page_url == undefined
          ) {
            if (filterData?.findVendor_name && filterData?.next_page_url) {
            } else {
              dispatch(clearFindVendors());
            }
          }
          let formData = new FormData();
          if (filterData?.findVendor_name)
            formData.append("category_name", filterData?.findVendor_name);
          else if (filterData?.category_id)
            formData.append("category_id", filterData?.category_id);
          const data = await Axios.post(
            Apis.findVendors(filterData?.next_page_url),
            // formData._parts.length > 0 ?
            formData,
            // : null
            await headers.config(),
          );

          if (data?.status == 200) {
            dispatch(hideLoading());
            resolve(true);
            dispatch(getFindVendors(data?.data?.data));
          }
        } catch (error) {
          dispatch(hideLoading());

          // console.log('error', error);
          reject(error);
          dispatch(
            showAlert({
              title: "getFindVendors",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  findVendorsByCat: (filterData) => {
    console.log("filterData", filterData);
    return (dispatch) => {
      dispatch(showLoading());
      if (filterData?.next_page_url) dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (
            filterData?.findVendor_name ||
            filterData?.next_page_url == undefined
          ) {
            if (filterData?.findVendor_name && filterData?.next_page_url) {
            } else {
              dispatch(clearFindVendorsByCat());
            }
          }
          let formData = new FormData();
          if (filterData?.findVendor_name)
            formData.append("vendor_name", filterData?.findVendor_name);
          formData.append("distance", filterData?.distance);
          if (filterData?.address)
            formData.append("location", filterData?.address);
          if (filterData?.lat)
            formData.append("distsance_lat", filterData?.lat);
          if (filterData?.lng)
            formData.append("distsance_lng", filterData?.lng);
          formData.append("category_id", filterData?.category_id);

          const data = await Axios.post(
            Apis.findVendorsbyCat(filterData?.next_page_url),
            formData,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(hideLoading());
            resolve(true);
            dispatch(getFindVendorsByCat(data?.data?.data));
          }
        } catch (error) {
          dispatch(hideLoading());
          console.log("error", error);
          reject(error);
          dispatch(
            showAlert({
              title: "getFindVendorsByCat",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  getDetails: (vendor_data) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("vendor_id", vendor_data?.vendor_id);
          if (vendor_data?.event_id)
            formData.append("event_id", vendor_data?.event_id);

          const data = await Axios.post(
            Apis.getVendorDetail,
            formData,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(getVendorDetails(data?.data?.data));
            resolve(true);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getDetails",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },
  getVendorDetails: (vendor_data) => {
    // console.log('vendor_data', vendor_data);
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("vendor_id", vendor_data?.vendor_id);
          if (vendor_data?.event_id)
            formData.append("event_id", vendor_data?.event_id);

          const data = await Axios.post(
            Apis.getVendorDetail,
            formData,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(hideLoading());

            resolve(data?.data?.data);
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "getVendorDetails",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  getYourVendors: (vendor_data) => {
    console.log("vendor_data", vendor_data);
    return (dispatch) => {
      console.log(vendor_data);
      if (vendor_data?.next_page_url) dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (
            vendor_data?.vendor_name ||
            vendor_data?.next_page_url == undefined
          ) {
            if (vendor_data?.vendor_name && vendor_data?.next_page_url) {
            } else {
              dispatch(clearYourVendors());
            }
          }
          let formData = new FormData();
          formData.append("vendor_name", vendor_data?.vendor_name);
          formData.append("event_id", vendor_data?.event_id);
          if (vendor_data?.category_id)
            formData.append("category_id", vendor_data?.category_id);
          const data = await Axios.post(
            Apis.getYourVendor(vendor_data?.next_page_url),
            formData,
            await headers.config(),
          );
          console.log("------------------");
          console.log(data?.data?.data);
          if (data?.status == 200) {
            // console.log("dataaaaaaaaa", data?.data?.data);
            resolve(true);
            dispatch(getYourVendors(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getYourVendors",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  addVendor: (vendor_data) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("first_name", vendor_data?.fname);
          formData.append("last_name", vendor_data?.lname);
          formData.append("email", vendor_data?.email);
          formData.append("contact_no", vendor_data?.contact);
          formData.append("address", vendor_data?.address);
          formData.append("lat", vendor_data?.lat);
          formData.append("lng", vendor_data?.lng);
          formData.append("service_category_id", vendor_data?.category);
          formData.append("service", vendor_data?.service);
          formData.append("website_link", vendor_data?.webLink);
          formData.append("event_id", vendor_data?.event_id);
          formData.append("about_the_vendor", vendor_data?.about);
          formData.append("add_document", vendor_data?.addDocument);
          if (vendor_data?.addDocument == 1) {
            for (const [i, element] of vendor_data?.documents.entries()) {
              formData.append(`attachments[${i}][file]`, element?.file);
              formData.append(`attachements[${i}][type]`, element?.media_type);
            }
          }
          const data = await Axios.post(
            Apis.createVendor,
            formData,
            await headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message }),
            );
            // dispatch(addNewVendor(data?.data?.data));
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "addVendor",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getVendorDetail: (vendor_id) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("vendor_id", vendor_id);
          const data = await Axios.post(
            Apis.getYourVendorDetail,
            formData,
            await headers.config(),
          );
          if (data?.status == 200) {
            resolve(data?.data?.data);
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "getVendorDetail",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        }
      });
    };
  },

  // updateVendor: vendor_data => {
  //   return dispatch => {
  //     dispatch(showLoading());
  //     return new Promise(async (resolve, reject) => {
  //       try {
  //         let formData = new FormData();
  //         formData.append('name', vendor_data?.name);
  //         formData.append('email', vendor_data?.email);
  //         formData.append('contact_no', vendor_data?.contact);
  //         formData.append('address', vendor_data?.address);
  //         formData.append('lat', vendor_data?.lat);
  //         formData.append('lng', vendor_data?.lng);
  //         formData.append('service_category_id', vendor_data?.category);
  //         formData.append('service', vendor_data?.service);
  //         formData.append('website_link', vendor_data?.webLink);
  //         formData.append('event_id', vendor_data?.event_id);
  //         formData.append('about_the_vendor', vendor_data?.about);
  //         formData.append('add_document', vendor_data?.addDocument);
  //         for (const [i, element] of vendor_data?.documents.entries()) {
  //           if (element?.id) {
  //             formData.append(`attachments[${i}][id]`, element?.id);
  //           } else {
  //             formData.append(`attachments[${i}][file]`, element);
  //           }
  //         }
  //         const data = await Axios.post(
  //           Apis.updateVendor,
  //           formData,
  //           await headers.config(),
  //         );
  //         if (data?.status == 200) {
  //           resolve(true);
  //           dispatch(showAlert({ message: data?.data?.message }));
  //         }
  //       } catch (error) {
  //         reject(error);
  //         dispatch(
  //           showAlert({
  //             title: 'updateVendor',
  //             message: error?.response?.data?.message,
  //             type: 'Error',
  //             status: error?.response?.status,
  //           }),
  //         );
  //       } finally {
  //         dispatch(hideLoading());
  //       }
  //     });
  //   };
  // },

  addToEvent: (vendor_data) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("vendor_id", vendor_data?.vendor_id);
          formData.append("event_id", vendor_data?.event_id);

          const data = await Axios.post(
            Apis.vendorAddToEvent,
            formData,
            await headers.config(),
          );
          if (data?.status == 200) {
            // console.log("data=====>>>>>", data);

            resolve(true);
            dispatch(
              showAlert({
                title: "addToEvent",
                message: data?.data?.message,
                type: "Success",
              }),
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "addToEvent",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  removeFromEvent: (vendor_data) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("vendor_id", vendor_data?.vendor_id);
          formData.append("event_id", vendor_data?.event_id);

          const data = await Axios.post(
            Apis.vendorRemoveToEvent,
            formData,
            await headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(removeVendorFromEvent(vendor_data?.vendor_id));
            dispatch(
              showAlert({
                title: "removeFromEvent",
                message: data?.data?.message,
                type: "Success",
              }),
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "removeFromEvent",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getSubContacts: (vendor_data) => {
    return (dispatch) => {
      dispatch(showLoading());
      if (vendor_data?.next_page_url) dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          if (vendor_data?.search || vendor_data?.next_page_url == undefined) {
            if (vendor_data?.search && vendor_data?.next_page_url) {
            } else {
              dispatch(clearSubContacts());
            }
          }
          let formData = new FormData();
          formData.append("vendor_id", vendor_data?.vendor_id);
          // formData.append("event_id", vendor_data?.event_id);
          if (vendor_data?.search)
            formData.append("vendor_name", vendor_data?.search);

          const data = await Axios.post(
            Apis.getSubVendors(vendor_data?.next_page_url),
            formData,
            await headers.config(),
          );
          if (data?.status == 200) {
            dispatch(hideLoading());
            resolve(true);
            dispatch(getSubContacts(data?.data?.data));
          }
        } catch (error) {
          dispatch(hideLoading());
          reject(error);
          dispatch(
            showAlert({
              title: "getSubContacts",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  createSubVendor: (subVendorData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("service_category_id", subVendorData?.category_id);
          formdata.append("first_name", subVendorData?.firstName);
          formdata.append("last_name", subVendorData?.lastName);
          formdata.append("email", subVendorData?.email);
          formdata.append("contact_no", subVendorData?.contact);
          formdata.append("address", subVendorData?.address);
          formdata.append("lat", subVendorData?.lat);
          formdata.append("lng", subVendorData?.lng);
          formdata.append("service", subVendorData?.service);
          formdata.append("about_the_vendor", subVendorData?.about);
          for (const [i, element] of subVendorData?.linkList.entries()) {
            formdata.append(`sociallinks[${i}][platform]`, element?.platform);
            formdata.append(`sociallinks[${i}][link]`, element?.link);
          }
          if (subVendorData?.selectedFile?.length > 0) {
            for (const [i, element] of subVendorData?.selectedFile.entries()) {
              formdata.append(`attachments[${i}][file]`, element?.file);
            }
          }
          if (subVendorData.images?.length > 0) {
            for (const [index, item] of subVendorData?.images.entries()) {
              formdata.append(`images[${index}]`, item);
            }
          }
          const data = await Axios.post(
            Apis.createSubVendor,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(updateSubContacts(data?.data?.data));
            dispatch(
              showAlert({
                title: "Add sub vendor",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              }),
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "Add sub vendor",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  updateStaffProfile: (userdata) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          if (userdata?.service) formdata.append("service", userdata?.service);
          if (userdata?.about)
            formdata.append("about_the_vendor", userdata?.about);
          if (userdata?.user_id) formdata.append("user_id", userdata.user_id);
          if (userdata.first_name)
            formdata.append("first_name", userdata.first_name);
          if (userdata.last_name)
            formdata.append("last_name", userdata.last_name);
          if (userdata.email) formdata.append("email", userdata.email);
          if (userdata.contact_no)
            formdata.append("contact_no", userdata.contact_no);
          if (userdata.image) formdata.append("image", userdata.image);
          if (userdata.dob) formdata.append("dob", userdata.dob);
          if (userdata.gender) formdata.append("gender", userdata.gender);
          if (userdata.address) formdata.append("address", userdata.address);
          if (userdata.lat) formdata.append("lat", userdata.lat);
          if (userdata.lng) formdata.append("lng", userdata.lng);
          if (userdata.socialLinks?.length > 0) {
            for (const [index, item] of userdata?.socialLinks.entries()) {
              formdata.append(`sociallinks[${index}][platform]`, item.platform);
              formdata.append(`sociallinks[${index}][link]`, item.link);
            }
          }
          // Business Information
          if (userdata?.comp_name)
            formdata.append("comp_name", userdata.comp_name);
          if (userdata?.comp_contact_no)
            formdata.append("comp_contact_no", userdata.comp_contact_no);
          if (userdata?.description)
            formdata.append("description", userdata.description);
          if (userdata?.start_time)
            formdata.append("start_time", userdata.start_time);
          if (userdata?.end_time)
            formdata.append("end_time", userdata.end_time);
          if (userdata?.service_price)
            formdata.append("service_price", userdata.service_price);
          if (userdata?.service_category)
            formdata.append("service_category_id", userdata.service_category);
          if (userdata?.service_offer)
            formdata.append("service_offer", userdata.service_offer);
          if (userdata?.schedule_type)
            formdata.append("schedule_type", userdata.schedule_type);
          if (userdata.availablity?.length > 0) {
            for (const [index, item] of userdata?.availablity.entries()) {
              formdata.append(`days[${index}][day]`, item.day);
            }
          }

          if (userdata.images?.length > 0) {
            for (const [index, item] of userdata?.images.entries()) {
              if (item?.id) {
                formdata.append(`images[${index}][id]`, item?.id);
              } else {
                formdata.append(`images[${index}][image]`, item);
              }
            }
          }

          if (userdata.documents?.length > 0) {
            for (const [index, item] of userdata?.documents.entries()) {
              if (item?.fileName) {
                formdata.append(`documents[${index}][doc]`, item?.file);
              } else {
                formdata.append(`documents[${index}][id]`, item?.id);
              }
            }
          }

          const data = await Axios.post(
            Apis.updateVendorProfile,
            formdata,
            await headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
              showAlert({
                title: "updateVendorProfile",
                message: data?.data?.message,
                type: "Success",
                status: data?.status,
              }),
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "updateVendorProfile",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  removeSubVendor: (subVendorData) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formData = new FormData();
          formData.append("id", subVendorData?.id);
          const data = await Axios.post(
            Apis.removeSubVendor,
            formData,
            await headers.config(),
          );
          if (data?.status == 200) {
            resolve(true);
          //  dispatch(getSubContacts(data?.data?.data));
        dispatch(removeSubVendor(subVendorData?.id));
            dispatch(
              showAlert({
                title: "removeFromSubVendor",
                message: data?.data?.message,
                type: "Success",
              }),
            );
          }
        } catch (error) {
          reject(error);
          dispatch(
            showAlert({
              title: "removeFromSubVendor",
              message: error?.response?.data?.message,
              type: "Error",
              status: error?.response?.status,
            }),
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
